<app-form-min-displays></app-form-min-displays>
<div class="d-flex">
  <div class="col-12 my-1">
    <button id="create-variable" class="btn btn-indigo float-right" type="submit" (click)="create()">
      <span>
        Ajouter un Panneau
      </span>
    </button>
    <button id="create-variable" class="mr-2 btn btn-indigo float-right" type="submit" (click)="create()">
      <span>
        Regles Affichage
      </span>
    </button>
  </div>
</div>
<div class="basic-container " style="margin-top: 10px;">
  <table mat-table [dataSource]="lstDisplays" multiTemplateDataRows class=" mat-elevation-z8">
    <!-- Nom -->
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef> Label </th>

      <td mat-cell *matCellDef="let element">
      <span >
          {{element.label}}
      </span>
    </td>
    </ng-container>

    <ng-container matColumnDef="msg">
      <th mat-header-cell *matHeaderCellDef> Message diffusé </th>
      <td mat-cell *matCellDef="let element">
        <span >
            {{element.msg}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="etat">
      <th mat-header-cell *matHeaderCellDef> Statut</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.etat == 'off' ">
          <i class="fa fa-circle text-danger" aria-hidden="true"
          style="cursor: pointer;" title="hors ligne"></i>
        </span>
        <span *ngIf="element.etat == 'on' ">
          <i class="fa fa-circle text-success" aria-hidden="true"
          style="cursor: pointer;" title="on ligne"></i>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="lastCom">
      <th mat-header-cell *matHeaderCellDef> Dernière Communication </th>
      <td mat-cell *matCellDef="let element">
        <span >
            {{element.lastCommunication| momentPipe:'DD/MM/YYYY hh:mm'}}
        </span>
      </td>
    </ng-container>

    <!-- Client -->
    <ng-container matColumnDef="automatic">
      <th mat-header-cell *matHeaderCellDef> Automatique </th>
      <td mat-cell *matCellDef="let element">
        <section class="example-section">
          <mat-slide-toggle
              class="example-margin" (change)="automaticDisplay(element,$event)"
              [checked]="element.automatic" >
          </mat-slide-toggle>
        </section>
       </td>
    </ng-container>

        <!-- Identifiant -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Actif </th>
      <td mat-cell *matCellDef="let element">
          <section class="example-section">
            <mat-slide-toggle
                class="example-margin" (change)="activateDisplay(element,$event)"
                [checked]="element.active" >
            </mat-slide-toggle>
          </section>
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <div class="buttons">
          <ng-container *ngIf="this.authenSer.isSupperAdmin">
            <div class="m-2">
              <span (click)="editDisplay(element)">
                <i class="fa fa-pencil-square-o text-primary" style="cursor: pointer;" aria-hidden="true"
                  title="Editer"></i>
              </span>
            </div>
            <div class="m-2">
              <span (click)="openDeleteConfirm(element.id)">
                <i class="fa fa-trash-o text-danger" style="cursor: pointer;" aria-hidden="true" title="Supprimer"></i>
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="this.authenSer.isAdmin">
            <div class="m-2">
              <span (click)="editDisplay(element)">
                <i class="fa fa-pencil-square-o text-primary" style="cursor: pointer;" aria-hidden="true"
                  title="Editer"></i>
              </span>
            </div>
            <div class="m-2">
              <span (click)="config(element)">
                <i class="fa fa-cogs text-success" style="cursor: pointer;" aria-hidden="true"
                  title="Configuration"></i>
              </span>
            </div>
            <ng-container *ngIf="!element.automatic">
              <div class="m-2">
                <span (click)="displayMsg(element)">
                  <i class="fa fa fa-commenting-o text-warning" style="cursor: pointer;" aria-hidden="true"
                    title="Editer"></i>
                </span>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row "
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element">
    </tr>
  </table>
</div>
